enum PathKey {
    TEMPLATE = 'TEMPLATE',
    HOME = 'HOME',
    SIGNUP = 'SIGNUP',
    ONBOARDING = 'ONBOARDING',
    MOBILE_NOT_SUPPORT = 'MOBILE_NOT_SUPPORT',
    MOBILE_WELCOME = 'MOBILE_WELCOME',
    SAVED_DRAFT = 'SAVED_DRAFT',
    REDIRECT = 'REDIRECT',
    DASHBOARD = 'DASHBOARD',
    APPOINTMENT = 'APPOINTMENT',
    APPOINTMENT_MANAGEMENT = 'APPOINTMENT_MANAGEMENT',
    APPOINTMENT_GOOGLE = 'APPOINTMENT_GOOGLE',
    APPOINTMENT_SETTING = 'APPOINTMENT_SETTING',
    QUESTIONS = 'QUESTIONS',
    CHANNEL_DETAIL = 'CHANNEL_DETAIL',
    CREATE_UNI_PROFILE = 'CREATE_UNI_PROFILE',
    OPERATION = 'OPERATION',
    PROVIDER_ONBOARD = 'PROVIDER_ONBOARD',
    PROVIDER_ONBOARD_DETAIL = 'PROVIDER_ONBOARD_DETAIL',
    LIST_TO_CHANNEL_DETAIL = 'LIST_TO_CHANNEL_DETAIL',
    LOGIN = 'LOGIN',
    CHANNEL_APPOINTMENT_SUCCESS = 'CHANNEL_APPOINTMENT_SUCCESS',
    CHANNEL_LANDING = 'CHANNEL_LANDING',
    CHANNEL_SURVEY = 'CHANNEL_SURVEY',
    PROVIDER = 'PROVIDER',
    PROVIDER_SEARCH = 'PROVIDER_SEARCH',
    CHANNEL = 'CHANNEL',
    CHANNEL_UPDATE = 'CHANNEL_UPDATE',
    SERVICES_TEMPLATE = 'SERVICES_TEMPLATE',
    RECOMMEND_CHANNELS = 'RECOMMEND_CHANNELS',
    PREVIEW = 'PREVIEW',
    ZOCDOC = 'ZOCDOC',
    AI_CHAT = 'AI_CHAT',
    UNIPROFILE_DETAIL = 'UNIPROFILE_DETAIL',
    PRACTICE_FRONT = 'PRACTICE_FRONT',
    PROSPECTS = 'PROSPECTS',
    CLIENTS = 'CLIENTS',
    CUSTOMIZE_PRACTICE_FRONT = 'CUSTOMIZE_PRACTICE_FRONT',
    GOOGLE = 'GOOGLE',
    YELP = 'YELP',
    PROSPECTS_MANAGE = 'PROSPECTS_MANAGE',
    PRACTICE_FRONT_VOTE_PAGE = 'PRACTICE_FRONT_VOTE_PAGE',
    PRACTICE_FRONT_CREATE_SUCCESS = 'PRACTICE_FRONT_CREATE_SUCCESS',
    PROSPECTS_DETAIL = 'PROSPECTS_DETAIL',
    GP_PROSPECTS_DETAIL = 'GP_PROSPECTS_DETAIL',
    OPS_MEMBER = 'OPS_MEMBER',
    DEV_WIHTELIST = 'DEV_WIHTELIST',
    ROLES = 'ROLES',
    ACCESS_DENIED = 'ACCESS_DENIED',
    PROVIDER_LOGIN = 'PROVIDER_LOGIN',
    RESET_PASSWORD = 'RESET_PASSWORD',
    PROVIDER_HOME = 'PROVIDER_HOME',
    PRACTICE_OVERVIEW = 'PRACTICE_OVERVIEW',
    INIT_UNIPROFILE = 'INIT_UNIPROFILE',
    NOT_FOUND = 'NOT_FOUND',
    VERIFICATION_FAIL = 'VERIFICATION_FAIL',
    SOMETHING_WENT_WRONG = 'SOMETHING_WENT_WRONG',
    UNDER_MAINTENANCE = 'UNDER_MAINTENANCE',
    DEV_GET_TOKEN = 'DEV_GET_TOKEN',
    HOME_CONFIG = 'HOME_CONFIG',
    HELLO_KLARITY = 'HELLO_KLARITY',
    KIWI_HEALTH = 'KIWI_HEALTH',
    PAY_SUCCESS = 'PAY_SUCCESS',
    CHANNEL_WITHDRRAW_DETAIL = 'CHANNEL_WITHDRRAW_DETAIL',
    CHANNEL_DETAIL_LIST_SUCCESS = 'CHANNEL_DETAIL_LIST_SUCCESS',
    REPUTATION_DASHBORAD = 'REPUTATION_DASHBORAD',
    REPUTATION_MANAGEMENT = 'REPUTATION_MANAGEMENT',
    REPUTATION_CONFIG_PAGE = 'REPUTATION_CONFIG_PAGE',
    REPUTATION_CONFIG_SUCCESS = 'REPUTATION_CONFIG_SUCCESS',
    AI_CONFIG = 'AI_CONFIG',
    UNIPROFILE_RESUME = 'UNIPROFILE_RESUME',
    HELLO_KLARITY_PROVIDERS = 'HELLO_KLARITY_PROVIDERS',
    CUSTOMIZE_PROVIDER_PROFILE_PAGE = 'CUSTOMIZE_PROVIDER_PROFILE_PAGE',
    CUSTOMIZE_PROVIDER_PROFILE_PAGE_PPA = 'CUSTOMIZE_PROVIDER_PROFILE_PAGE_PPA',
    HELLO_KLARITY_MAPPING_GOLIVE_SUCCESS = 'HELLO_KLARITY_MAPPING_GOLIVE_SUCCESS',
    HELLO_KLARITY_MAPPING_PAUSE_SUCCESS = 'HELLO_KLARITY_MAPPING_PAUSE_SUCCESS',
    HELLO_KLARITY_PAGE_MANAGEMENT = 'HELLO_KLARITY_PAGE_MANAGEMENT',
    HELLO_KLARITY_PAGE_DETAIL = 'HELLO_KLARITY_PAGE_DETAIL',
    HELLO_KLARITY_PROVIDER_RESOURCES = 'HELLO_KLARITY_PROVIDER_RESOURCES',
    CHANNEL_NOT_FOUND = 'CHANNEL_NOT_FOUND',
    SALES_PROVIDER_EXP = 'SALES_PROVIDER_EXP',
    CONTRACT_LINK_PAGE = 'CONTRACT_LINK_PAGE',
    CONFIGURATIONS = 'CONFIGURATIONS',
    EHR_ONBOARDING = 'EHR_ONBOARDING',
    EHR_CART = 'EHR_CART',
    EHR_ADD_ON_OPS = 'EHR_ADD_ON_OPS',
    EHR_ADD_ON_PROVIDER = 'EHR_ADD_ON_PROVIDER',
    EHR_HOME_PROVIDER = 'EHR_HOME_PROVIDER',
    EHR_ADD_ON_DETAIL = 'EHR_ADD_ON_DETAIL',
    KLARITY_PLAN_PROCESS = 'KLARITY_PLAN_PROCESS',
    KIWI_KNOWLEDEG = 'KIWI_KNOWLEDEG',
    KLARITY_SUBSCRIPTION = 'KLARITY_SUBSCRIPTION',
    KLARITY_AGREEMENT = 'KLARITY_AGREEMENT',
    KLARITY_REVIEWS = 'KLARITY_REVIEWS',
    KLARITY_REVIEWS_DETAIL = 'KLARITY_REVIEWS_DETAIL',
    AVA_SETTING = 'AVA_SETTING',
    KLARITY_ASSESSMENT = 'KLARITY_ASSESSMENT',
    KLARITY_ASSESSMENT_DETAIL = 'KLARITY_ASSESSMENT_DETAIL',
    KLARITY_SELECT_PROGRAMS_DETAIL = 'KLARITY_SELECT_PROGRAMS_DETAIL',
    TESTING = 'TESTING',
    HELP_CENTER = 'HELP_CENTER',
    CALENDAR = 'CALENDAR',
    CALENDAR_SETTING = 'CALENDAR_SETTING',
    PAYMENT_SETUP = 'PAYMENT_SETUP',
    PAYMENT_SETUP_SUCCESS = 'PAYMENT_SETUP_SUCCESS',
    SERVICE_SETTING = 'SERVICE_SETTING',
    SERVICE_SETTING_SUCCESS = 'SERVICE_SETTING_SUCCESS',
    INBOX = 'INBOX',
    CLOSED_FUNNEL = 'CLOSED_FUNNEL',
    CLOSED_FUNNEL_DETAIL = 'CLOSED_FUNNEL_DETAIL',
    MEDICATION_SETTINGS = 'MEDICATION_SETTINGS',
    MEDICATION_SETTINGS_SUCCESS = 'MEDICATION_SETTINGS_SUCCESS',
    MEDICATION_LIST_PAGE_MANAGEMENT = 'MEDICATION_LIST_PAGE_MANAGEMENT',
    CHANNEL_PAYMENT = 'CHANNEL_PAYMENT',
    CHANNEL_PAYMENT_SUCCESS = 'CHANNEL_PAYMENT_SUCCESS',
    PPA_LEAD_FORM = 'PPA_LEAD_FORM',
    CREDENTIALING_LANDING = 'CREDENTIALING_LANDING',
    CREDENTIALING_START = 'CREDENTIALING_START',
    CREDENTIALING_SUBMITTED = 'CREDENTIALING_SUBMITTED',
    INSURANCE_BILLING_LANDING = 'INSURANCE_BILLING_LANDING',
    INSURANCE_BILLING_ONBOARDING = 'INSURANCE_BILLING_ONBOARDING',
    INSURANCE_BILLING_ONBOARDING_SUBMITTED = 'INSURANCE_BILLING_ONBOARDING_SUBMITTED',
    PPA_SIGNUP = 'PPA_SIGNUP',
    PPA_LOGIN = 'PPA_LOGIN',
    OPS_THIRD_PARTY_PAGE = 'OPS_THIRD_PARTY_PAGE',
    MARKETING = 'MARKETING',
    MARKETING_SETTING = 'MARKETING_SETTING',
    PRO_LISTING_SETUP = 'PRO_LISTING_SETUP',
    PRO_LISTING_SUCCESS = 'PRO_LISTING_SUCCESS',
    PPA_ONBOARDING_FINISH = 'PPA_ONBOARDING_FINISH',
    PPA_ONBOARDING_STEPS = 'PPA_ONBOARDING_STEPS',
    PPA_ONBOARDING_ADVANCE_SETTING = 'PPA_ONBOARDING_ADVANCE_SETTING',
    PPA_ONBOARDING_REVIEW = 'PPA_ONBOARDING_REVIEW',
    PPA_DASHBOARD = 'PPA_DASHBOARD',
    PPA_REDIRECT = 'PPA_REDIRECT',
    PPA_RESET_PASSWORD = 'PPA_RESET_PASSWORD',
    SWITCH_ACCOUNT_REDIRECT = 'SWITCH_ACCOUNT_REDIRECT',
    SWITCH_ACCOUNT_NOTICE = 'SWITCH_ACCOUNT_NOTICE',
    PPA_ONBOARDING_ADVANCE_SETTING_SUCCESS = 'PPA_ONBOARDING_ADVANCE_SETTING_SUCCESS',
    PROFILE = 'PROFILE',
    PPA_PROVIDER_DETAIL = 'PPA_PROVIDER_DETAIL',
    GROUP_PRACTICE_DETAIL = 'GROUP_PRACTICE_DETAIL',
    GP_STAFF_DETAIL = 'GP_STAFF_DETAIL',
    PPA_SERVICE_TEMPLATE = 'PPA_SERVICE_TEMPLATE',
    CLEAR_SESSION = 'CLEAR_SESSION',
    TEXT_VISIT = 'TEXT_VISIT',
    TEXT_VISIT_EMBEDDABLE_WORKFLOWS = 'TEXT_VISIT_EMBEDDABLE_WORKFLOWS',
    INTAKE_WORKFLOWS = 'INTAKE_WORKFLOWS',
    INTAKE_WORKFLOWS_DETAIL = 'INTAKE_WORKFLOWS_DETAIL',
    TEXT_VISIT_CASE = 'TEXT_VISIT_CASE',
    TEXT_VISIT_PROVIDER = 'TEXT_VISIT_PROVIDER',
    EMBEDDABLE_WORKFLOWS_DETAIL = 'EMBEDDABLE_WORKFLOWS_DETAIL',
    VISUAL_FLOW_BUILDER = 'VISUAL_FLOW_BUILDER',
    PRESCRIPTIONS = 'PRESCRIPTIONS',
    TEXT_VISIT_PROVIDER_CASE = 'TEXT_VISIT_PROVIDER_CASE',
    FINANCIALS = 'FINANCIALS',
    INSURANCE_BILLING = 'INSURANCE_BILLING',
    CREDENTIALING = 'CREDENTIALING',
    VIDEO_PREPARE = 'VIDEO_PREPARE',
    MEETING = 'MEETING',
    MEETING_END = 'MEETING_END',
    MESSAGES = 'MESSAGES',
    EFAX = 'EFAX',
    PROVIDER_SELECT_ORG = 'PROVIDER_SELECT_ORG',
    INVITED_PROVIDER_ONBOARDING_ACTIVATE = 'INVITED_PROVIDER_ONBOARDING_ACTIVATE',
    INVITED_PROVIDER_ONBOARDING_CREATE_PROFILE = 'INVITED_PROVIDER_ONBOARDING_CREATE_PROFILE',
    INVITED_PROVIDER_ONBOARDING_SERVICES = 'INVITED_PROVIDER_ONBOARDING_SERVICES',
    INVITED_PROVIDER_ONBOARDING_AVAILABILITY = 'INVITED_PROVIDER_ONBOARDING_AVAILABILITY',
    INVITED_PROVIDER_ONBOARDING_MARKETING_PROFILE = 'INVITED_PROVIDER_ONBOARDING_MARKETING_PROFILE',
    INVITED_PROVIDER_ONBOARDING_REVIEW = 'INVITED_PROVIDER_ONBOARDING_REVIEW',
    REVIEW_PROVIDER_PROFILE = 'REVIEW_PROVIDER_PROFILE',
    SELECT_PRACTICE = 'SELECT_PRACTICE',
    INVITED_PROVIDER_GO_LIVE = 'INVITED_PROVIDER_GO_LIVE',
    INVITED_PROVIDER_ADVANCED_SETTINGS = 'INVITED_PROVIDER_ADVANCED_SETTINGS',
    INVITED_PROVIDER_ADVANCED_SETTINGS_SUCCESS = 'INVITED_PROVIDER_ADVANCED_SETTINGS_SUCCESS',
    ADD_GROUP_PROVIDER = 'ADD_GROUP_PROVIDER',
    GROUP_CREDENTIALING = 'GROUP_CREDENTIALING',
    ADD_CREDENTIALING_PROVIDER = 'ADD_CREDENTIALING_PROVIDER',
    SELECT_WEBSITE_PROVIDERS = 'SELECT_WEBSITE_PROVIDERS',
    GP_ANALYTICS = 'GP_ANALYTICS',
    GP_APPLICATIONS = 'GP_APPLICATIONS',
    GP_AUDIT_LOG = 'GP_AUDIT_LOG',
    GP_OVERVIEW = 'GP_OVERVIEW',
    GP_REASSIGN_LOG = 'GP_REASSIGN_LOG',
}

export const PATH: Record<PathKey, string> = {
    [PathKey.TEMPLATE]: '/template',
    [PathKey.HOME]: '/',
    [PathKey.SIGNUP]: '/signup',
    [PathKey.ONBOARDING]: '/onboarding',
    [PathKey.MOBILE_NOT_SUPPORT]: '/mobile-not-support',
    [PathKey.MOBILE_WELCOME]: '/mobile-welcome',
    [PathKey.SAVED_DRAFT]: '/saved-draft',
    [PathKey.REDIRECT]: '/redirect',
    [PathKey.DASHBOARD]: '/dashboard',
    [PathKey.APPOINTMENT]: 'appointment',
    [PathKey.APPOINTMENT_MANAGEMENT]: 'appointment-management',
    [PathKey.APPOINTMENT_GOOGLE]: 'appointment-google',
    [PathKey.APPOINTMENT_SETTING]: 'appointment-setting',
    [PathKey.QUESTIONS]: 'questions',
    [PathKey.CHANNEL_DETAIL]: 'channel-detail',
    [PathKey.CREATE_UNI_PROFILE]: '/create-uni-profile',
    [PathKey.OPERATION]: '/operation',
    [PathKey.PROVIDER_ONBOARD]: 'provider-onboard',
    [PathKey.PROVIDER_ONBOARD_DETAIL]: 'provider-onboard-detail',
    [PathKey.LIST_TO_CHANNEL_DETAIL]: 'list-to-channel-detail',
    [PathKey.LOGIN]: 'login',
    [PathKey.CHANNEL_APPOINTMENT_SUCCESS]: 'channel-success',
    [PathKey.CHANNEL_LANDING]: 'channel-landing',
    [PathKey.CHANNEL]: 'channel',
    [PathKey.CHANNEL_SURVEY]: 'channel-survey',
    [PathKey.PROVIDER]: 'provider',
    [PathKey.PROVIDER_SEARCH]: 'provider-search',
    [PathKey.CHANNEL_UPDATE]: 'channel-update',
    [PathKey.SERVICES_TEMPLATE]: 'services-template',
    [PathKey.RECOMMEND_CHANNELS]: 'recomend-channels',
    [PathKey.PREVIEW]: 'preview',
    [PathKey.ZOCDOC]: 'zocdoc',
    [PathKey.GOOGLE]: 'google',
    [PathKey.YELP]: 'yelp',
    [PathKey.AI_CHAT]: '/aichat',
    [PathKey.UNIPROFILE_DETAIL]: 'uniprofile-detail',
    [PathKey.PRACTICE_FRONT]: 'practice-front',
    [PathKey.PROSPECTS]: 'prospects',
    [PathKey.CUSTOMIZE_PRACTICE_FRONT]: 'customize-practice-front',
    [PathKey.PROSPECTS_MANAGE]: 'prospects-manage',
    [PathKey.AVA_SETTING]: 'ava-setting',
    [PathKey.PRACTICE_FRONT_VOTE_PAGE]: 'practice-front-vote',
    [PathKey.PRACTICE_FRONT_CREATE_SUCCESS]: 'practice-front-success',
    [PathKey.PROSPECTS_DETAIL]: 'prospects-detail',
    [PathKey.GP_PROSPECTS_DETAIL]: 'group-practice/prospects-detail',
    [PathKey.OPS_MEMBER]: 'ops-member',
    [PathKey.DEV_WIHTELIST]: 'dev-whitelist',
    [PathKey.ROLES]: 'roles',
    [PathKey.ACCESS_DENIED]: 'access-denied',
    [PathKey.PROVIDER_LOGIN]: 'provider-login',
    [PathKey.PROVIDER_HOME]: 'home',
    [PathKey.PRACTICE_OVERVIEW]: 'practice-overview',
    [PathKey.RESET_PASSWORD]: '/reset-password',
    [PathKey.INIT_UNIPROFILE]: '/init-uniprofile',
    [PathKey.NOT_FOUND]: '/not-found',
    [PathKey.VERIFICATION_FAIL]: '/verification-fail',
    [PathKey.SOMETHING_WENT_WRONG]: '/something-went-wrong',
    [PathKey.UNDER_MAINTENANCE]: '/under-maintenance',
    [PathKey.DEV_GET_TOKEN]: '/__DEV__/view-token',
    [PathKey.HOME_CONFIG]: 'home-config',
    [PathKey.HELLO_KLARITY]: 'hello-klarity',
    [PathKey.KIWI_HEALTH]: 'kiwi-health',
    [PathKey.PAY_SUCCESS]: '/paysuccess',
    [PathKey.CHANNEL_WITHDRRAW_DETAIL]: 'channel-withdraw-detail',
    [PathKey.CHANNEL_DETAIL_LIST_SUCCESS]: 'channel-detail-success',
    [PathKey.REPUTATION_MANAGEMENT]: 'reputation-management',
    [PathKey.REPUTATION_DASHBORAD]: 'reputation-dashboard',
    [PathKey.REPUTATION_CONFIG_PAGE]: '/reputation-config',
    [PathKey.REPUTATION_CONFIG_SUCCESS]: 'reputation-config-success',
    [PathKey.AI_CONFIG]: 'ai-config',
    [PathKey.CONFIGURATIONS]: 'configurations',
    [PathKey.UNIPROFILE_RESUME]: 'uniprofile-resume',
    [PathKey.HELLO_KLARITY_PROVIDERS]: 'hello-klarity-providers',
    [PathKey.CUSTOMIZE_PROVIDER_PROFILE_PAGE]: 'customize-provider-profile-page',
    [PathKey.CUSTOMIZE_PROVIDER_PROFILE_PAGE_PPA]: 'customize-provider-profile-page-ppa',
    [PathKey.HELLO_KLARITY_MAPPING_GOLIVE_SUCCESS]: 'mapping-golive-success',
    [PathKey.HELLO_KLARITY_MAPPING_PAUSE_SUCCESS]: 'mapping-pause-success',
    [PathKey.HELLO_KLARITY_PAGE_MANAGEMENT]: 'hello-klarity-page-management',
    [PathKey.HELLO_KLARITY_PAGE_DETAIL]: 'hello-klarity-page-detail',
    [PathKey.HELLO_KLARITY_PROVIDER_RESOURCES]: 'hello-klarity-provider-resources',
    [PathKey.CHANNEL_NOT_FOUND]: 'channel-not-found',
    [PathKey.SALES_PROVIDER_EXP]: 'new-client',
    [PathKey.CONTRACT_LINK_PAGE]: 'contract-link',
    [PathKey.EHR_ONBOARDING]: 'ehr-onboarding',
    [PathKey.EHR_CART]: 'ehr-cart',
    [PathKey.EHR_ADD_ON_OPS]: 'ehr-add-on',
    [PathKey.EHR_HOME_PROVIDER]: 'ehr-home',
    [PathKey.EHR_ADD_ON_PROVIDER]: 'ehr-add-on',
    [PathKey.EHR_ADD_ON_DETAIL]: 'ehr-add-on-detail',
    [PathKey.KLARITY_PLAN_PROCESS]: 'klarity-plan-process',
    [PathKey.KIWI_KNOWLEDEG]: 'kiwi-knowledge',
    [PathKey.KLARITY_SUBSCRIPTION]: 'klarity-subscription',
    [PathKey.KLARITY_AGREEMENT]: 'klarity-agreement',
    [PathKey.KLARITY_REVIEWS]: 'klarity-reviews',
    [PathKey.KLARITY_REVIEWS_DETAIL]: 'klarity-reviews-detail',
    [PathKey.KLARITY_ASSESSMENT]: 'klarity-assessment',
    [PathKey.KLARITY_ASSESSMENT_DETAIL]: 'klarity-assessment-detail',
    [PathKey.KLARITY_SELECT_PROGRAMS_DETAIL]: 'klarity-programs-detail',
    [PathKey.TESTING]: 'testing',
    [PathKey.HELP_CENTER]: 'help-center',
    [PathKey.CALENDAR]: 'calendar',
    [PathKey.CALENDAR_SETTING]: 'calendar-setting',
    [PathKey.CLIENTS]: 'clients',
    [PathKey.PAYMENT_SETUP]: 'payment-setup',
    [PathKey.PAYMENT_SETUP_SUCCESS]: 'payment-setup-success',
    [PathKey.SERVICE_SETTING]: 'service-setting',
    [PathKey.SERVICE_SETTING_SUCCESS]: 'service-setting-success',
    [PathKey.INBOX]: 'inbox',
    [PathKey.CLOSED_FUNNEL]: 'closed-funnel',
    [PathKey.CLOSED_FUNNEL_DETAIL]: 'closed-funnel-detail',
    [PathKey.MEDICATION_SETTINGS]: '/medication-settings',
    [PathKey.MEDICATION_SETTINGS_SUCCESS]: '/medication-settings-success',
    [PathKey.MEDICATION_LIST_PAGE_MANAGEMENT]: 'medication-list-page-management',
    [PathKey.CHANNEL_PAYMENT]: '/channel-payment',
    [PathKey.CHANNEL_PAYMENT_SUCCESS]: '/channel-payment-success',
    [PathKey.PPA_LEAD_FORM]: '/ppa-lead-form',
    [PathKey.CREDENTIALING_LANDING]: '/credentialing/landing',
    [PathKey.CREDENTIALING_START]: '/credentialing/start',
    [PathKey.CREDENTIALING_SUBMITTED]: '/credentialing/submitted',
    [PathKey.INSURANCE_BILLING_LANDING]: '/billing/landing',
    [PathKey.INSURANCE_BILLING_ONBOARDING]: '/insurance-billing/onboarding',
    [PathKey.INSURANCE_BILLING_ONBOARDING_SUBMITTED]: '/insurance-billing/onboarding/submitted',
    [PathKey.PPA_SIGNUP]: '/ppa-signup',
    [PathKey.PPA_LOGIN]: '/signin',
    [PathKey.OPS_THIRD_PARTY_PAGE]: 'ops-third-party-page',
    [PathKey.MARKETING]: 'marketing',
    [PathKey.MARKETING_SETTING]: 'marketing-setting',
    [PathKey.PRO_LISTING_SETUP]: 'pro-listing-setup',
    [PathKey.PRO_LISTING_SUCCESS]: '/pro-listing-success',
    [PathKey.PPA_ONBOARDING_FINISH]: '/ppa-onboarding-finish',
    [PathKey.PPA_ONBOARDING_STEPS]: '/ppa-onboarding-steps',
    [PathKey.PPA_ONBOARDING_ADVANCE_SETTING]: '/ppa-onboarding-advance-setting',
    [PathKey.PPA_ONBOARDING_REVIEW]: '/ppa-onboarding-review',
    [PathKey.PPA_DASHBOARD]: '/ppa-dashboard',
    [PathKey.PPA_REDIRECT]: '/ppa-redirect',
    [PathKey.PPA_RESET_PASSWORD]: '/ppa-reset-password',
    [PathKey.SWITCH_ACCOUNT_REDIRECT]: '/switch-account-redirect',
    [PathKey.SWITCH_ACCOUNT_NOTICE]: '/switch-account-notice',
    [PathKey.PPA_ONBOARDING_ADVANCE_SETTING_SUCCESS]: '/ppa-onboarding-advance-setting-success',
    [PathKey.PROFILE]: 'profile',
    [PathKey.PPA_PROVIDER_DETAIL]: 'ppa-provider-detail',
    [PathKey.GROUP_PRACTICE_DETAIL]: 'group-practice-detail',
    [PathKey.GP_STAFF_DETAIL]: 'group-practice/staff-detail',
    [PathKey.PPA_SERVICE_TEMPLATE]: 'ppa-service-template',
    [PathKey.CLEAR_SESSION]: '/clear-session',
    [PathKey.TEXT_VISIT]: 'text-visit',
    [PathKey.PRESCRIPTIONS]: 'prescriptions',
    [PathKey.TEXT_VISIT_EMBEDDABLE_WORKFLOWS]: 'embeddable-workflows',
    [PathKey.INTAKE_WORKFLOWS]: 'intake-workflows',
    [PathKey.TEXT_VISIT_CASE]: 'cases',
    [PathKey.TEXT_VISIT_PROVIDER]: 'text-visit-provider',
    [PathKey.EMBEDDABLE_WORKFLOWS_DETAIL]: 'embeddable-workflows-detail',
    [PathKey.INTAKE_WORKFLOWS_DETAIL]: 'intake-workflows-detail',
    [PathKey.VISUAL_FLOW_BUILDER]: 'visual-flow-builder',
    [PathKey.TEXT_VISIT_PROVIDER_CASE]: 'text-visit-provider-case',
    [PathKey.FINANCIALS]: 'financials',
    [PathKey.INSURANCE_BILLING]: 'insurance-billing',
    [PathKey.CREDENTIALING]: 'credentialing',
    [PathKey.VIDEO_PREPARE]: 'video-prepare',
    [PathKey.MEETING]: 'meeting',
    [PathKey.MEETING_END]: 'meeting-end',
    [PathKey.MESSAGES]: 'messages',
    [PathKey.EFAX]: 'eFax',
    [PathKey.PROVIDER_SELECT_ORG]: 'provider-select-org',
    [PathKey.INVITED_PROVIDER_ONBOARDING_ACTIVATE]: '/invited-provider/onboarding/activate',
    [PathKey.INVITED_PROVIDER_ONBOARDING_CREATE_PROFILE]: '/invited-provider/onboarding/create-profile',
    [PathKey.INVITED_PROVIDER_ONBOARDING_SERVICES]: '/invited-provider/onboarding/services',
    [PathKey.INVITED_PROVIDER_ONBOARDING_AVAILABILITY]: '/invited-provider/onboarding/availability',
    [PathKey.INVITED_PROVIDER_ONBOARDING_MARKETING_PROFILE]: '/invited-provider/onboarding/marketing-profile',
    [PathKey.INVITED_PROVIDER_ONBOARDING_REVIEW]: '/invited-provider/onboarding/review',
    [PathKey.REVIEW_PROVIDER_PROFILE]: '/review-provider-profile',
    [PathKey.SELECT_PRACTICE]: '/select-practice',
    [PathKey.INVITED_PROVIDER_GO_LIVE]: '/invited-provider/go-live',
    [PathKey.INVITED_PROVIDER_ADVANCED_SETTINGS]: '/invited-provider/advanced-settings',
    [PathKey.INVITED_PROVIDER_ADVANCED_SETTINGS_SUCCESS]: '/invited-provider/advanced-settings/success',
    [PathKey.ADD_GROUP_PROVIDER]: '/add-group-provider',
    [PathKey.GROUP_CREDENTIALING]: '/group-credentialing',
    [PathKey.ADD_CREDENTIALING_PROVIDER]: '/add-credentialing-provider',
    [PathKey.SELECT_WEBSITE_PROVIDERS]: '/select-website-providers',
    [PathKey.GP_ANALYTICS]: 'gp-analytics',
    [PathKey.GP_APPLICATIONS]: 'gp-applications',
    [PathKey.GP_AUDIT_LOG]: 'gp-audit-log',
    [PathKey.GP_OVERVIEW]: 'gp-overview',
    [PathKey.GP_REASSIGN_LOG]: 'gp-reassign-log',
};

export const withoutBasicAPICallingPath = [
    PATH.HOME,
    `/${PATH.LOGIN}`,
    PATH.SIGNUP,
    `/${PATH.PROVIDER_LOGIN}`,
    PATH.RESET_PASSWORD,
    PATH.REDIRECT,
    PATH.VERIFICATION_FAIL,
    PATH.MOBILE_NOT_SUPPORT,
    `/${PATH.ACCESS_DENIED}`,
    PATH.NOT_FOUND,
    PATH.SOMETHING_WENT_WRONG,
    `/${PATH.SALES_PROVIDER_EXP}`,
    PATH.MOBILE_WELCOME,
    PATH.REDIRECT,
    PATH.VERIFICATION_FAIL,
    PATH.PPA_LEAD_FORM,
    PATH.PPA_LOGIN,
    `/${PATH.PROVIDER_SELECT_ORG}`,
    PATH.SELECT_PRACTICE,
    PATH.INVITED_PROVIDER_ONBOARDING_ACTIVATE,
    PATH.SWITCH_ACCOUNT_REDIRECT,
    PATH.SWITCH_ACCOUNT_NOTICE,
];

export const loginPages = [
    `/${PATH.LOGIN}`,
    PATH.SIGNUP,
    `/${PATH.PROVIDER_LOGIN}`,
    PATH.RESET_PASSWORD,
    PATH.REDIRECT,
    PATH.VERIFICATION_FAIL,
    PATH.MOBILE_NOT_SUPPORT,
    `/${PATH.ACCESS_DENIED}`,
    PATH.NOT_FOUND,
    PATH.SOMETHING_WENT_WRONG,
    `/${PATH.SALES_PROVIDER_EXP}`,
    PATH.MOBILE_WELCOME,
    PATH.REDIRECT,
    PATH.VERIFICATION_FAIL,
    PATH.PROVIDER_SELECT_ORG,
    PATH.SELECT_PRACTICE,
    PATH.INVITED_PROVIDER_ONBOARDING_ACTIVATE,
    PATH.SWITCH_ACCOUNT_REDIRECT,
    PATH.SWITCH_ACCOUNT_NOTICE,
    PATH.PPA_LOGIN,
];

export const supportsMobile = [
    `/${PATH.SALES_PROVIDER_EXP}`,
    '/',
    `${PATH.SIGNUP}`,
    `/${PATH.PROVIDER_LOGIN}`,
    PATH.MOBILE_WELCOME,
    PATH.REDIRECT,
    PATH.VERIFICATION_FAIL,
    PATH.PPA_ONBOARDING_STEPS,
    PATH.PPA_LEAD_FORM,
    PATH.PPA_SIGNUP,
    PATH.PPA_LOGIN,
    PATH.PPA_ONBOARDING_REVIEW,
    PATH.PROVIDER_SELECT_ORG,
    PATH.SELECT_PRACTICE,
    PATH.INVITED_PROVIDER_ONBOARDING_ACTIVATE,
    PATH.INVITED_PROVIDER_ONBOARDING_CREATE_PROFILE,
    PATH.INVITED_PROVIDER_ONBOARDING_SERVICES,
    PATH.INVITED_PROVIDER_ONBOARDING_AVAILABILITY,
    PATH.INVITED_PROVIDER_ONBOARDING_MARKETING_PROFILE,
    PATH.INVITED_PROVIDER_ONBOARDING_REVIEW,
    PATH.INVITED_PROVIDER_GO_LIVE,
];

export const dontShowAdvertisingPaht = [`/${PATH.SALES_PROVIDER_EXP}`, PATH.MOBILE_NOT_SUPPORT, ...loginPages];
